import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'GB/components/RentOrOwn/RentOrOwn';

export class RentOrOwn extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        rentOrOwnOptions: PropTypes.object.isRequired
    };

    render() {
        const { intl, rentOrOwnOptions } = this.props;

        return (
            <Field
                id="residentStatus"
                name="residentStatus"
                component={SelectField}
                optionList={mapOptionsToSelectField(rentOrOwnOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.rentOrOwn`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.rentOrOwn`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.RENT_OR_OWN_NULL`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object
    rentOrOwnOptions: _.get(state, `serverData.messages.${LOCALE_PREFIX}.rentOrOwnOptions`)
});

export default connect(mapStateToProps)(injectIntl(RentOrOwn));

